import React from 'react';
import { useLocation } from 'react-router-dom';
import { Breadcrumb } from './Breadcrumb.tsx';
import { ADMIN_PATHS, ADMIN_ROUTE_TITLES } from '../../../routing/adminPaths.ts';

const Header: React.FC = () => {
  const location = useLocation();

  const getPageTitle = (): string => {
    const path = location.pathname;
    if (ADMIN_ROUTE_TITLES[path]) return ADMIN_ROUTE_TITLES[path];
    if (path.match(new RegExp(`^${ADMIN_PATHS.ORGANIZATIONS}/[^/]+$`))) return 'Organization';
    if (path.match(new RegExp(`^${ADMIN_PATHS.USERS}/[^/]+$`))) return 'User';
    if (path.startsWith(ADMIN_PATHS.USERS)) return 'Users';
    if (path.startsWith(ADMIN_PATHS.INTEGRATION_TYPES)) return 'Integration Types';
    if (path.startsWith(ADMIN_PATHS.INTEGRATIONS)) return 'Integrations';
    return 'Admin';
  };

  return (
    <header className="bg-white border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{getPageTitle()}</h1>
          <Breadcrumb />
        </div>
      </div>
    </header>
  );
};

export default Header;
